import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Provider } from '@vgtv/api-client';

import { config } from '../config.js';

const localesMeta = import.meta.glob('./locales/*.json');
const lng = config.provider === Provider.VGTV ? 'no' : 'se';

const fetchLocale = async () => {
  const localeFile = Object.keys(localesMeta).find((path) =>
    path.includes(`/${lng}.json`)
  );
  const json = (await localesMeta[localeFile!]()) as { default: object };
  return json.default;
};

export default fetchLocale().then(async (translation) => {
  return i18next.use(initReactI18next).init({
    debug: process.env.NODE_ENV === 'development',
    lng,
    resources: {
      [lng]: { translation },
    },
    keySeparator: false,
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
  });
});
